export const LIGHT_THEME_STAR = {
  on: "#FFE234",
  off: "#6D7A88",
};

export const DARK_THEME_STAR = {
  on: "#FFE234",
  off: "#6D7A88",
};
